import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["onClick", "innerHTML"]

import { nextTick, onMounted, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseTabs',
  setup(__props) {

const tabs = ref<Record<string, HTMLElement>>({});
const activeTabKey = ref<string | null>(null);
const root = ref<InstanceType<typeof HTMLElement>>();
const $tabs = ref<HTMLElement[] | undefined>();
const scrollContainer = ref<InstanceType<typeof HTMLElement>>();

const changeTab = (tabKey: string | null) => {
  activeTabKey.value = tabKey;

  Object.values(tabs.value).forEach((tab: HTMLElement) => {
    tab.classList.remove('active');
  });

  if (typeof tabKey === 'string' && tabs.value[tabKey]) {
    tabs.value[tabKey].classList.add('active');
  }
};

const showScrollShadow = ref(false);

const scrollBarShadowHandler = () => {
  showScrollShadow.value = true;

  if (scrollContainer.value) {
    const {
      offsetWidth,
      scrollWidth,
      scrollLeft,
    } = scrollContainer.value;

    if (offsetWidth < scrollWidth) {
      if ((scrollWidth - offsetWidth) === scrollLeft) {
        showScrollShadow.value = false;
      }
    }
  }
};

onMounted(() => {
  setTimeout(() => {
    $tabs.value = [...(root.value?.querySelectorAll('.base-tab') || [])] as HTMLElement[];

    const tabsCount = $tabs.value?.length || 0;

    let activeTab = null as string | null;

    for (let i = 0; i < tabsCount; i += 1) {
      const $tab = $tabs.value?.[i];

      if ($tab) {
        const $title = $tab.querySelector('.base-tab__title');

        if ($title) {
          const title = `${$title.innerHTML}`.trim();

          if (title !== '') {
            tabs.value[title] = $tab;
            if (activeTab === null) {
              activeTab = title;
            }
          }
        }
      }
    }

    if (Object.keys($tabs.value).length) {
      nextTick(() => {
        changeTab(activeTab);
      });
    }
  }, 10);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "base-tabs",
    ref_key: "root",
    ref: root
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["base-tabs__nav", { 'scroll-shadow': showScrollShadow.value }])
    }, [
      _createElementVNode("div", {
        class: "scroll-container",
        ref_key: "scrollContainer",
        ref: scrollContainer,
        onScroll: scrollBarShadowHandler
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, ($tab, title) => {
          return (_openBlock(), _createElementBlock("button", {
            key: `elb-${title}`,
            onClick: _withModifiers(($event: any) => (changeTab(title)), ["prevent"]),
            class: _normalizeClass({ 'active': activeTabKey.value === title }),
            innerHTML: title
          }, null, 10, _hoisted_1))
        }), 128))
      ], 544)
    ], 2),
    _renderSlot(_ctx.$slots, "default")
  ], 512))
}
}

})